var map = {
	"./icon_patent.png": "8f7c",
	"./icon_patent_en.png": "fa9f",
	"./icon_patent_es.png": "7af1",
	"./icon_patent_hk.png": "23fc",
	"./icon_patent_pt.png": "70d9",
	"./icon_patent_tr.png": "e157"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4f36";